export const FILE_SIZE = 100 * 1024 * 1024
export const FILE_SIZE_SMALL = 5 * 1024 * 1024
export const SUPPORTED_FORMATS = ['application/pdf']
